import { render, staticRenderFns } from "./StepActivity.vue?vue&type=template&id=b086eb06"
import script from "./StepActivity.vue?vue&type=script&lang=js"
export * from "./StepActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b086eb06')) {
      api.createRecord('b086eb06', component.options)
    } else {
      api.reload('b086eb06', component.options)
    }
    module.hot.accept("./StepActivity.vue?vue&type=template&id=b086eb06", function () {
      api.rerender('b086eb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/translations/StepActivity.vue"
export default component.exports